import React from 'react';

import S from './Contacts.module.css';

export const ContactsImg = () => (
  <div className={S.root}>
    <div className={S.leftSide}>
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
      <hr />
    </div>
    <div className={S.rightSide}>
      a<br />b<br />c<br />d<br />e<br />f
    </div>
    <div className={S.profile}>
      <div className={S.head}></div>
      <div className={S.neck}></div>
    </div>
  </div>
);
